// @flow

import styles from './AppInstallBanner.less';

export const rootStyle = {
  [styles.root]: true
};

export const getStylesForPosition = (position: AppInstallBanner$Position) => ({
  [styles.bottom]: position === 'bottom',
  [styles.top]: position === 'top',
  [styles.fullPage]: position === 'full-page'
});

export const getStylesForTransition = (
  transition: AppInstallBanner$Transition,
  state: 'entered' | 'exited'
) => ({
  [styles.slideUp]: transition === 'slideUp',
  [styles.fade]: transition === 'fade',
  [styles.slideUpIn]: transition === 'slideUp' && state === 'entered',
  [styles.fadeIn]: transition === 'fade' && state === 'entered',
  [styles.slideUpOut]: transition === 'slideUp' && state === 'exited',
  [styles.fadeOut]: transition === 'fade' && state === 'exited'
});
